<template>
  <div class="main-menubox row flex-nowrap justify-content-between align-items-center mb-2">
    <div class="col-4 pt-0">
<!--  <div class="main-menubox d-flex my-2">-->
    <!-- old <n-button v-for="(item,index) in menuitems"
        :key="index"
        type="default" 
        link 
        @click="$router.push(item.link)" 
        v-bind:class="{active:type==item.id}"
    >
        <span>{{item.name}}</span>
    </n-button> -->
    <!--    <n-button-->
    <!--        v-if="!$store.state.user.check_is_wxcblog_domain()"-->
    <!--        class="pl-0 pr-3"-->
    <!--        type="default" -->
    <!--        link -->
    <!--        @click="$router.push('/blog/follows')" -->
    <!--        v-bind:class="{active:type==0}"-->
    <!--    >-->
    <!--        <span>{{$t('message').blog.menu_follow}}</span>-->
    <!--&lt;!&ndash;      <span><i class="el-icon-user-solid "></i>我的</span>&ndash;&gt;-->
    <!--    </n-button>-->
    <router-link
        v-if="!$store.state.user.check_is_wxcblog_domain()"
        :to="'/blog/follows'"
        class="pl-0 pr-3"
        v-bind:class="{active:type==0}"
    >
      {{$t('message').blog.menu_follow}}
    </router-link>
    <!-- 关注   <n-button-->
    <!--        type="default" -->
    <!--        link-->
    <!--        class="pl-0"-->
    <!--        @click="$router.push('/blog')"-->
    <!--        v-bind:class="{active:type==1}"-->
    <!--    >-->
    <!--        <span>{{$t('message').blog.menu_recommend}}</span>-->
    <!--    </n-button>-->
    <router-link
        :to="'/blog/'"
        class="pl-0 pr-3"
        v-bind:class="{active:type==1}"
    >
      {{ $t('message').blog.menu_recommend }}
    </router-link>
    <!--    <n-button-->
    <!--        type="default" -->
    <!--        link -->
    <!--        @click="$router.push('/blog/hot')"-->
    <!--        v-bind:class="{active:type==2}"-->
    <!--    >-->
    <!--        <span>{{$t('message').blog.menu_hot}}</span>-->
    <!--    </n-button>-->
    <router-link
        :to="'/blog/hot'"
        class="pl-0 pr-3"
        v-bind:class="{active:type==2}"
    >

      {{ $t('message').blog.menu_hot }}
    </router-link>
    <!--    <n-button-->
    <!--        type="default" -->
    <!--        link -->
    <!--        @click="$router.push('/blog/new')"-->
    <!--        v-bind:class="{active:type==3}"-->
    <!--    >-->
    <!--        <span>最新</span>-->
    <!--    </n-button>-->
    <router-link
        :to="'/blog/new'"
        class="pl-0 pr-3"
        v-bind:class="{active:type==3}"
    >最新
    </router-link>
   </div>
   <div  class="col-4 d-flex justify-content-end align-items-center px-0" v-if="$store.state.user.check_is_wxcblog_domain() && $store.state.user.userinfo.id">

      <n-button
                type="primary"
                simple
                @click="$router.push('/blog/my/editor/')"
                class="editbtn">
        <i class="el-icon-edit"></i>
        {{ $t('message').topnav.editbtn }}
      </n-button>
<!--      <el-dropdown-->
<!--          @command="goGroupBlogEditer"-->
<!--          trigger="click"-->
<!--          v-if="$store.state.user.groupBlogger && $store.state.user.userinfo.id">-->
<!--        <n-button-->
<!--            type="primary"-->
<!--            round-->
<!--            simple-->
<!--            class="editbtn">-->
<!--          <icon-pen class="editicon"></icon-pen>-->
<!--          {{ $t('message').topnav.editbtn }}<i class="ml-2 el-icon-arrow-down"></i>-->
<!--        </n-button>-->
<!--        <el-dropdown-menu slot="dropdown">-->
<!--          <el-dropdown-item disabled>{{ $t('message').topnav.editbtn_dropdown_0 }}</el-dropdown-item>-->
<!--          <el-dropdown-item :command="this.$store.state.user.userinfo">我的博客</el-dropdown-item>-->
<!--          <el-dropdown-item v-for="item in this.$store.state.user.groupBlogger" :key="item.id" :command="item">-->
<!--            {{ item.bloggerinfo_bloggerID.name }}-->
<!--          </el-dropdown-item>-->
<!--        </el-dropdown-menu>-->
<!--      </el-dropdown>-->
    </div>
   </div>

</template>
<script>
import {
  Button,
} from '@/components';

export default {
  name: 'main-menu',
  props: {
    type: String,
  },
  components: {
    [Button.name]: Button,
  },
  methods: {
      post(id) {
        if (!this.check_user_login()) return;
        {
        this.$router.push({path: "/blog/my/editor/"})
        }
      }
  },
  data() {
    return {
      menuitems: [
        {id: '0', name: this.$t('message').blog.menu_follow, link: '/blog/follows'},
        {id: '1', name: this.$t('message').blog.menu_recommend, link: '/blog'},
        {id: '2', name: this.$t('message').blog.menu_hot, link: '/blog/hot'},
        {id: '3', name: '最新', link: '/blog/new'}
      ]
    }
  }
};
</script>
<style scoped>
.main-menubox a {
  /*font-size: 1.125rem !important;*/
  font-size: 18px !important;
  font-weight: 500;
  margin-right: 1rem;
  color: #657786;

}

.main-menubox span:hover {
  color: black
}

.main-menubox button {
  margin: 0;
  margin-top: -5px;
  margin-bottom: 5px;
}

.main-menubox .active {
  color: black;
  font-weight: 600
}

/*.main-menubox .active {*/
/*  cursor: default !important;*/
/*}*/

textarea {
  border: #ddd 1px solid;
  border-radius: 5px
}

textarea:focus {
  border: 1px solid #8590a6;;
  outline: none
}
</style>
